module.exports = __webpack_public_path__ + "img/icon-price.f2597fde.png";